import CustomBreadcrumbs from '@/components/custom-breadcrumbs/index.vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { globalLoader } from '@/helpers/variables'
import {VueSlideToggle} from 'vue-slide-toggle'

export default {
    name: 'PartnersPage',
    components: {
        CustomBreadcrumbs,
        VueSlideToggle,
    },
    data() {
        return {
            selectedRegion: null,
            openItems: [],
            isMobile: false,
            isMobileSidebarOpen: false,
        }
    },
    computed: {
        ...mapGetters({
            partners: 'partners/partners',
            isAuthenticated: `auth/isAuthenticated`,

        }),
        currentRegionData() {
            if (!this.selectedRegion) return null
            return this.partners.partners.data[this.selectedRegion]
        },
    },
    methods: {
        ...mapActions({
            getPartners: 'partners/GET_PARTNERS_LIST',
        }),
        ...mapMutations({
            changeRegisterPopup: 'popups/CHANGE_REGISTRATION_POPUP',
        }),
        selectRegion(region) {
            this.selectedRegion = region;
            this.openItems = [];
            console.log(this.partners.partners.data[this.selectedRegion]);
            this.openItems.push(Object.keys(this.partners.partners.data[this.selectedRegion])[0]);
        },
        toggleItem(item) {
            if (this.openItems.includes(item)) {
                this.openItems = this.openItems.filter(i => i !== item)
            } else {
                this.openItems.push(item)
            }
        },
        isOpen(item) {
            return this.openItems.includes(item)
        },
        toggleMobileSidebar() {
            this.isMobileSidebarOpen = !this.isMobileSidebarOpen
        },
        closeMobileSidebar() {
            this.isMobileSidebarOpen = false
        },
        checkMobile() {
            this.isMobile = window.innerWidth <= 768
            if (!this.isMobile) {
                this.isMobileSidebarOpen = false
            }
        },
        handleResize() {
            this.checkMobile()
        },
    },
    async created() {
        globalLoader(true)
        const response = await this.getPartners()
        this.selectRegion(Object.keys(response.partners.data)[0])
        globalLoader(false)
    },
    mounted() {
        this.checkMobile()
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    },
}